import React from 'react';

import '../style/Loader.css';

const Loader = () => (
	<div className="fullpage col-lg-12 d-flex justify-content-center align-items-center">
		<div className="loader">
		  <div className="dot"></div>
		  <div className="dot"></div>
		  <div className="dot"></div>
		  <div className="dot"></div>
		  <div className="dot"></div>
		</div>
	</div>
);

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader.js